import React from 'react';
import {
  GoogleMapsRoute,
  Coordinates,
} from '../../../../../../components/GoogleMapsRoute';

type CarMileageMapSectionProps = {
  startCoords: Coordinates | null;
  endCoords: Coordinates | null;
};

export const CarMileageMapSection: React.FC<CarMileageMapSectionProps> = ({
  startCoords,
  endCoords,
}) => {
  return (
    <div className="mapContainer">
      <GoogleMapsRoute startCoords={startCoords} endCoords={endCoords} />
    </div>
  );
};
